import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import {updateLastActionTime} from '../../redux/actions/page';

const mapStateToProps = () => Object.create(null);
const mapDispatchToProps = dispatch => ({
	updateNavigationTime() {
		dispatch(updateLastActionTime());
	}
});

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentDidMount() {
			this.props.updateNavigationTime();
		},
		componentWillUnmount() {
			this.props.updateNavigationTime();
		}
	}),
);

export default enhance;



// WEBPACK FOOTER //
// ./src/client/pages/admin/with-action-time.js